import React, { useEffect } from "react";

import {
    Box,
    Button,
    Grid,
    Paper,
    Typography,
    Tabs,
    Tab,
    IconButton,
    Tooltip,
} from "@material-ui/core";

import {
    Close,
    ShoppingCart,
    Store,
    AccountBalance,
    Assessment,
    Settings,
    Description,
    Receipt,
    AssignmentReturn,
    ShoppingBasket,
    SwapHoriz,
    Today,
    CloudUpload,
    SystemUpdate,
    Tune,
    AccountBalanceWallet,
    BarChart,
    ListAlt,
    Business,
    LocalShipping,
    Autorenew,
    Security,
    Dashboard,
    People,
    PlaylistAddCheck,
    Group,
    Edit,
    PersonAdd,
    Assignment,
    Payment,
    Timeline,
    VerifiedUser,
    VpnKey,
    Money,
    Straighten,
    Widgets,
    Category,
    DonutSmall,
    MonetizationOn,
    MenuBook,
    Public,
    LocationCity,
    Map,
    AccountTree,
    ViewModule,
    Work,
    LocalGasStation,
    LocalOffer,
    EventSeat,
    TableChart,
    TrendingUp,
} from "@material-ui/icons";

import "./DeptScreen.css";
import { inshs, itmes } from "../../Context/Local";
import { getLS } from "../../utils/useLS";
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/*
  إعدادات الأنظمة
  كل نظام له:
  1- لون مستقل.
  2- عنوان مستقل.
  3- أيقونة مستقلة.
  4- خيارات خاصة به.
  5- عدد صفحات قابل للتغيير.
*/
let pScr = getLS("premiScr", {});

export const SYSTEM_CONFIG = {
    sales: {
        id: "sales",
        name: "sales-title",
        color: "#159447",
        dark: "#08783b",
        light: "#e3f5e9",
        icon: ShoppingCart,
        pages: [
            [
                {
                    title: "sale-invoice",
                    icon: Receipt,
                    action: "salesInvoice",
                    nmbr: "(1)",
                    path: "Invoces",
                    disb: pScr.sal,
                    insh: inshs.Sales.sal,
                },
                {
                    title: "sale-billet",
                    icon: AssignmentReturn,
                    nmbr: "(2)",
                    path: "Invoces",
                    disb: pScr.salRet,
                    insh: inshs.Sales.salRet,
                },
                {
                    title: "invoice-price",
                    nmbr: "(3)",
                    path: "Invoces",
                    disb: pScr.salView,
                    insh: inshs.Sales.salViw,
                    icon: Description,
                },
                {
                    title: "closing-invoice",
                    nmbr: "(4)",
                    path: "ReportEqfalEveryDay",
                    disb: pScr.eqfDay,
                    icon: Assessment,
                },
                {
                    title: "daily-rpt",
                    nmbr: "(5)",
                    path: "ReporteveryDay",
                    disb: pScr.evrDay,
                    icon: Today,
                    action: "dailyMovement",
                },
                {
                    title: "close_shifts_report",
                    nmbr: "(6)",
                    path: "Shifts",
                    disb: pScr.activ,
                    icon: ListAlt,
                    action: "shiftClosing",
                },
            ],
            [
                {
                    title: "active-rpt",
                    nmbr: "(7)",
                    path: "Activity",
                    disb: pScr.activ,
                    icon: BarChart,
                    action: "salesReport",
                },
                {
                    title: "sale-tax-rpt",
                    nmbr: "(8)",
                    path: "sale-report-tax",
                    disb: pScr.tafseel,
                    insh: inshs.Sales.saleVat,
                    icon: AccountBalanceWallet,
                    action: "customerStatement",
                },
                {
                    title: "sale-detail-rpt",
                    nmbr: "(9)",
                    path: "ReportSalTafsele",
                    disb: pScr.tafseel,
                    icon: ShoppingBasket,
                    action: "salesOrders",
                },
                {
                    title: "sale-analysis-rpt",
                    nmbr: "(10)",
                    path: "ReportSaleAnalysis",
                    disb: pScr.saleAnalysis,
                    icon: Assessment,
                    action: "salesDetails",
                },
                {
                    title: "sale-employee",
                    nmbr: "(11)",
                    path: "ReportEmpSales",
                    disb: pScr.empSale,
                    icon: BarChart,
                    action: "salesReturnsReport",
                },
                {
                    title: "sale-profit",
                    nmbr: "(12)",
                    path: "CurrencySalesProfit",
                    disb: pScr.saleProfit,
                    icon: BarChart,
                    action: "salesSettings",
                },
            ],
            [
                {
                    title: "sales_payment_report",
                    nmbr: "(8)",
                    path: "SadadInvoices",
                    icon: "",
                    disb: pScr.tafseel,
                    insh: inshs.Sales.saleVat,
                    title: "تحليل المبيعات",
                    icon: BarChart,
                    action: "salesAnalysis",
                },
                {
                    title: "profit-margin",
                    nmbr: "(13)",
                    path: "ReportProfitMargin",
                    disb: pScr.profitMargin,
                    icon: Business,
                    action: "customerMovement",
                },
                {
                    title: "salesman_sales_report",
                    nmbr: "(15)",
                    path: "salesPersonComm",
                    disb: true,
                    icon: Business,
                    action: "salesItems",
                },
                {
                    title: "فاتورة أولية",
                    nmbr: "(3)",
                    path: "Invoces",
                    disb: pScr.salView,
                    insh: inshs.Sales.salAwleya,
                    icon: AccountBalance,
                    action: "representativeStatement",
                },
                {
                    title: "resturant_invoice",
                    nmbr: "14",
                    path: "rest-invoice",
                    disb: pScr.sal,
                    insh: inshs.Sales.sal,
                    icon: Assessment,
                    action: "salesProfits",
                },
                {
                    title: "dashboard",
                    nmbr: "(16)",
                    path: "chart",
                    disb: pScr.chart,
                    icon: Tune,
                    action: "salesSystemSettings",
                },
            ],
            [
                {
                    title: "اشعار مدين",
                    nmbr: "(3)",
                    path: "Invoces",
                    disb: pScr.sal,
                    insh: inshs.Sales.isharDept,
                    icon: Description,
                    action: "salesExtraReports",
                },
                {
                    title: "اشعار دائن",
                    nmbr: "(3)",
                    path: "Invoces",
                    disb: pScr.sal,
                    insh: inshs.Sales.isharCredit,
                    icon: Description,
                    action: "customers",
                },
                {
                    title: "امر عمل",
                    nmbr: "(3)",
                    path: "Invoces",
                    disb: pScr.salView,
                    insh: inshs.Sales.salWorkOrder,
                    icon: SwapHoriz,
                    action: "salesItemMovement",
                },

            ],
        ],
    },
    purchases: {
        id: "purchases",
        name: "purchases-title",
        color: "#079da4",
        dark: "#007e86",
        light: "#def7f7",
        icon: ShoppingBasket,

        pages: [
            [
                {
                    title: "purchase-invoice",
                    nmbr: "(1)",
                    path: "Invoces",
                    disb: pScr.purch,
                    insh: inshs.Purches.purch,
                    icon: Receipt,
                    action: "purchaseInvoice",
                },
                {
                    title: "return-purchase",
                    nmbr: "(2)",
                    path: "Invoces",
                    disb: pScr.purchRet,
                    insh: inshs.Purches.purchRet,
                    icon: AssignmentReturn,
                    action: "purchaseReturn",
                },
                {
                    title: "purchase-order",
                    nmbr: "(3)",
                    path: "Invoces",
                    disb: pScr.purchRet,
                    insh: inshs.Purches.purchOrder,
                    icon: ShoppingCart,
                    action: "purchaseOrder",
                },
                {
                    title: "purch-employee",
                    nmbr: "(4)",
                    path: "ReportEmpPurches",
                    disb: pScr.activ,
                    icon: Business,
                    action: "employeePurchases",
                },
                {
                    title: "activity-purchase-report",
                    nmbr: "(5)",
                    path: "Activityp",
                    disb: pScr.activ,
                    icon: BarChart,
                    action: "purchaseBusinessReport",
                },
                {
                    title: "puchases-details-reprt",
                    nmbr: "(6)",
                    path: "PurchaseDetails",
                    disb: pScr.saleAnalysis,
                    icon: Assessment,
                    action: "purchaseDetails",
                },
            ],
            [
                {
                    title: "purchases-payment-report",
                    nmbr: "(5)",
                    path: "SadadInvoices",
                    disb: pScr.activ,
                    insh: inshs.Sales.purchVat,
                    icon: SwapHoriz,
                    action: "purchaseMovement",
                },
                {
                    title: "puchases-vat-report",
                    nmbr: "(5)",
                    path: "sale-report-tax",
                    disb: pScr.activ,
                    insh: inshs.Sales.purchVat,
                    icon: AccountBalanceWallet,
                    action: "supplierStatement",
                },
                {
                    title: "purch-analysis-rpt",
                    nmbr: "(6)",
                    path: "ReportPurchAnalysis",
                    disb: pScr.saleAnalysis,
                    icon: Assessment,
                    action: "purchaseReports",
                },

            ],
        ],
    },
    safes: {
        id: "warehouse",
        name: "stores-title",
        color: "#3837b5",
        dark: "#211e91",
        light: "#e8e8ff",
        icon: Store,

        pages: [
            [
                {
                    title: "store-first-term",
                    nmbr: "(1)",
                    path: "Invoces",
                    disb: pScr.safe,
                    insh: inshs.Safes.safe,
                    icon: ListAlt,
                    action: "openingStock",
                },
                {
                    title: "str-inv-stat",
                    nmbr: "(2)",
                    path: "ReportSafesJard",
                    disb: pScr.safJrd,
                    icon: ListAlt,
                    action: "warehouseInventory",
                },
                {
                    title: "str-inv-stat-unit",
                    nmbr: "(3)",
                    path: "SafeGrdUnits",
                    disb: pScr.safJrd,
                    icon: Assessment,
                    action: "warehouseInventoryUnits",
                },
                {
                    title: "str-adjustment",
                    nmbr: "(4)",
                    path: "reStore",
                    disb: pScr.safJrd,
                    icon: Tune,
                    action: "stockAdjustment",
                },
                {
                    title: "str-item-trans",
                    nmbr: "(5)",
                    path: "curr-details-rpt",
                    disb: pScr.safJrd,
                    icon: SwapHoriz,
                    action: "specificItemMovement",
                },
                {
                    title: "totals_movement_item",
                    nmbr: "(6)",
                    path: "ItemsTotalMovement",
                    disb: pScr.safJrd,
                    icon: BarChart,
                    action: "itemMovementReport",
                },
            ],
            [
                {
                    title: "made_order",
                    nmbr: "(1)",
                    path: "Invoces",
                    disb: pScr.safe,
                    insh: inshs.Safes.manufacturing,
                    icon: LocalShipping,
                    action: "warehouseTransfer",
                },
                {
                    title: "str-transfer",
                    nmbr: "(7)",
                    path: "StoreTransfer",
                    disb: true,
                    icon: Description,
                    action: "stockIssue",
                },
                {
                    title: "str-receipt",
                    nmbr: "(11)",
                    path: "ReceiveST",
                    disb: true,
                    icon: Receipt,
                    action: "stockReceipt",
                },
                {
                    title: "str-twreed",
                    nmbr: "(7)",
                    path: "store-supp",
                    disb: true,
                    icon: Assessment,
                    action: "stockBalances",
                },
                {
                    title: "str-srf",
                    nmbr: "(8)",
                    path: "store-exch",
                    disb: true,
                    icon: Assessment,
                    action: "warehouseItems",
                },
                {
                    title: "str-turnover",
                    nmbr: "(6)",
                    path: "trun-items-avg",
                    disb: pScr.safJrd,
                    icon: TrendingUp,
                    action: "warehouseSettings",
                },
            ],
        ],
    },
    customers: {
        id: "reports",
        name: "customers-and-suppliers-title",
        color: "#85008f",
        dark: "#85008f",
        light: "#f4eafa",
        icon: People,

        pages: [
            [
                {
                    title: "cust-add",
                    nmbr: "(1)",
                    path: "Customers",
                    disb: pScr.addCust,
                    insh: inshs.Customers[0],
                    icon: PersonAdd,
                    action: "reportsSales",
                },
                {
                    title: "sup-add",
                    nmbr: "(2)",
                    path: "Customers",
                    disb: pScr.addCust,
                    insh: inshs.Customers[1],
                    icon: PersonAdd,
                    action: "reportsPurchases",
                },
                {
                    title: "basic-customer-data",
                    nmbr: "(3)",
                    path: "SimData",
                    disb: pScr.groupCust,
                    insh: inshs.bascData.Acts,
                    icon: Group,
                    action: "reportsWarehouse",
                },
                {
                    title: "cust-account",
                    nmbr: "(4)",
                    path: "HesabCustA",
                    disb: pScr.custAcc,
                    insh: inshs.Customers[2],
                    icon: Assignment,
                    action: "reportsAccounts",
                },
                {
                    title: "sup-account",
                    nmbr: "(5)",
                    path: "HesabCustM",
                    disb: pScr.custAcc,
                    insh: inshs.Customers[3],
                    icon: Assignment,
                    action: "dailyReports",
                },
                {
                    title: "cust-balance",
                    nmbr: "(6)",
                    path: "BalanceCustRPT",
                    disb: pScr?.custBalance,
                    insh: inshs.Customers[4],
                    icon: Assessment,
                    action: "detailedReports",
                },
            ],
            [
                {
                    title: "cust-last-pay",
                    nmbr: "(8)",
                    path: "pay-trans",
                    disb: pScr.custPayTrans,
                    icon: Payment,
                    action: "profitReports",
                },
                {
                    title: "أعمار الديون",
                    nmbr: "(9)",
                    path: "AgelPeriod",
                    disb: pScr.custPayTrans,
                    icon: Timeline,
                    action: "taxReports",
                },

            ],
        ],
    },
    accounts: {
        id: "accounts",
        name: "accounts-title",
        color: "#888888",
        dark: "#888888",
        light: "#f3f3f3",
        icon: Edit,

        pages: [
            [
                {
                    title: "accounts-tree",
                    nmbr: "(1)",
                    path: "accounts-index",
                    disb: pScr.accountTree,
                    icon: ListAlt,
                    action: "accountsTree",
                },
                {
                    title: "account-report",
                    nmbr: "(2)",
                    path: "ReportAcc",
                    disb: pScr.acc,
                    icon: Description,
                    action: "journalEntries",
                },
                {
                    title: "ext-receipt",
                    nmbr: "(3)",
                    path: "ext-receipt",
                    disb: pScr.sandQKh,
                    insh: inshs.Accounts.sQKharji,
                    icon: Receipt,
                    action: "receiptVoucher",
                },
                {
                    title: "ext-exchange",
                    nmbr: "(4)",
                    path: "ext-exchange",
                    disb: pScr.sandSKh,
                    insh: inshs.Accounts.sSKharji,
                    icon: Receipt,
                    action: "paymentVoucher",
                },
                {
                    title: "int-receipt",
                    nmbr: "(5)",
                    path: "int-receipt",
                    disb: pScr.sandQD,
                    insh: inshs.Accounts.internalSQ,
                    icon: Assessment,
                    action: "trialBalance",
                },
                {
                    title: "int-exchange",
                    nmbr: "(6)",
                    path: "int-exchange",
                    disb: pScr.sandSD,
                    insh: inshs.Accounts.internalSS,
                    icon: AccountBalanceWallet,
                    action: "accountStatement",
                },
            ],
            [
                {
                    title: "mult-receipt",
                    nmbr: "(7)",
                    path: "mult-receipt",
                    disb: pScr.multiQ,
                    icon: ListAlt,
                    action: "generalLedger",
                },
                {
                    title: "mult-exchange",
                    nmbr: "(8)",
                    path: "mult-exchange",
                    disb: pScr.multiS,
                    icon: BarChart,
                    action: "incomeStatement",
                },
                {
                    title: "القيود الأفتتاحية",
                    nmbr: "(14)",
                    path: "opening-rest",
                    disb: true,
                    icon: AccountBalance,
                    action: "balanceSheet",
                },
                {
                    title: "daily-rest",
                    nmbr: "(11)",
                    path: "restInsert",
                    disb: pScr.restInsert,
                    icon: Today,
                    action: "annualClosing",
                },
                {
                    title: "tax-dec",
                    nmbr: "(12)",
                    path: "reportTax",
                    disb: pScr.taxRPT,
                    icon: Settings,
                    action: "accountSettings",
                },
                {
                    title: "الاقرار الضريبي 2",
                    nmbr: "(12)",
                    path: "VatReports",
                    disb: pScr.taxRPT,
                    icon: Assessment,
                    action: "accountReports",
                },
            ],
            [
                {
                    title: "acc-sys-rpt",
                    path: "MainRBalance",
                    disb: pScr.accountRPT,
                    icon: ListAlt,
                    action: "generalLedger",
                },
                {
                    title: "تقرير تحليل مراكز التكلفة",
                    nmbr: "",
                    path: "costRpt",
                    disb: pScr.accountRPT,
                    icon: BarChart,
                    action: "incomeStatement",
                },
                {
                    title: "تقرير اليومية العامة",
                    nmbr: "",
                    path: "DailyJenral",
                    disb: pScr.accountRPT,
                    icon: AccountBalance,
                    action: "balanceSheet",
                },
            ],
        ],
    },
    basicData: {
        id: "settings",
        name: "input-basic-data",
        color: "#d65e62",
        dark: "#d65e62",
        light: "#edf5fd",
        icon: PlaylistAddCheck,
        pages: [
            [
                {
                    title: "basic-found-data",
                    nmbr: "(1)",
                    path: "Foundation",
                    disb: pScr.found,
                    insh: inshs.bascData.Foundation,
                    icon: Business,
                    action: "defaultSettings",
                },
                {
                    title: "basic-unit-data",
                    nmbr: "(2)",
                    path: "SimData",
                    disb: pScr.unit,
                    insh: inshs.bascData.Units,
                    icon: Straighten,
                    action: "systemUpdates",
                },
                {
                    title: "basic-product-data",
                    nmbr: "(3)",
                    path: "item",
                    disb: pScr.item,
                    insh: itmes,
                    icon: Widgets,
                    action: "importExport",
                },
                {
                    title: "basic-group-product",
                    nmbr: "(4)",
                    path: "groups",
                    disb: pScr.itemGroup,
                    insh: inshs.bascData.groups,
                    icon: Category,
                    action: "zakatSettings",
                },
                {
                    title: "basic-group-tax",
                    nmbr: "(5)",
                    path: "SimData",
                    disb: pScr.taxGroup,
                    insh: inshs.bascData.tax_groups,
                    icon: Category,
                    action: "electronicScale",
                },
                {
                    title: "basic-branch-data",
                    nmbr: "(6)",
                    path: "NormData",
                    disb: pScr.branch,
                    insh: inshs.bascData.Branches,
                    icon: Receipt,
                    action: "generalSettings",
                },
            ],
            [
                {
                    title: "basic-safe-data",
                    nmbr: "(7)",
                    path: "safes",
                    disb: pScr.safes,
                    insh: inshs.bascData.Safes,
                    icon: Tune,
                    action: "defaultSettings",
                },
                {
                    title: "basic-stock-data",
                    nmbr: "(8)",
                    path: "stocks",
                    disb: pScr.stocks,
                    insh: inshs.bascData.Stocks,
                    icon: AccountBalanceWallet,
                    action: "systemUpdates",
                },
                {
                    title: "basic-bank-data",
                    nmbr: "(7)",
                    path: "banks",
                    disb: pScr.bank,
                    insh: inshs.bascData.Banks,
                    icon: AccountBalance,
                    action: "importExport",
                },
                {
                    title: "basic-center-data",
                    nmbr: "(8)",
                    path: "costCenters",
                    disb: pScr.centr,
                    insh: inshs.bascData.costcenter,
                    icon: DonutSmall,
                    action: "zakatSettings",
                },
                {
                    title: "basic-omla-data",
                    nmbr: "(9)",
                    path: "Omlat",
                    disb: pScr.omla,
                    insh: inshs.bascData.omlat,
                    icon: MonetizationOn,
                    action: "electronicScale",
                },
                {
                    title: "basic-books-data",
                    nmbr: "(10)",
                    path: "SimData",
                    disb: pScr.accBook,
                    insh: inshs.bascData.AccountBooks,
                    icon: MenuBook,
                    action: "generalSettings",
                },
            ],
            [
                {
                    title: "basic-customer-data",
                    nmbr: "(11)",
                    path: "SimData",
                    disb: pScr.custGroup,
                    insh: inshs.bascData.Acts,
                    icon: Tune,
                    action: "defaultSettings",
                },
                {
                    title: "basic-countery-data",
                    nmbr: "(14)",
                    path: "SimData",
                    disb: pScr.country,
                    insh: inshs.bascData.Countries,
                    icon: Public,
                    action: "systemUpdates",
                },
                {
                    title: "basic-cities-data",
                    nmbr: "(15)",
                    path: "SimData",
                    disb: pScr.city,
                    insh: inshs.bascData.Cities,
                    icon: LocationCity,
                    action: "importExport",
                },
                {
                    title: "basic-area-data",
                    nmbr: "(16)",
                    path: "SimData",
                    disb: pScr.area,
                    insh: inshs.bascData.Areas,
                    icon: Map,
                    action: "zakatSettings",
                },
                {
                    title: "basic-div-data",
                    nmbr: "(17)",
                    path: "SimData",
                    disb: pScr.mang,
                    insh: inshs.bascData.Managements,
                    icon: AccountTree,
                    action: "electronicScale",
                },
                {
                    title: "basic-depart-data",
                    nmbr: "(18)",
                    path: "SimData",
                    disb: pScr.dept,
                    insh: inshs.bascData.Departments,
                    icon: ViewModule,
                    action: "generalSettings",
                },
            ],
            [
                {
                    title: "basic-jobs-data",
                    nmbr: "(19)",
                    path: "SimData",
                    disb: pScr.job,
                    insh: inshs.bascData.jobs,
                    icon: Work,
                    action: "defaultSettings",
                },
                {
                    title: "bsic-card-pay",
                    nmbr: "(20)",
                    path: "SimData",
                    disb: pScr.cardType,
                    insh: inshs.bascData.CardTypes,
                    icon: SystemUpdate,
                    action: "systemUpdates",
                },
                {
                    title: "تعريف المندوبين",
                    nmbr: "(12)",
                    path: "salesPerson",
                    disb: pScr.salesmen,
                    icon: PersonAdd,
                    action: "importExport",
                },
                {
                    title: "تعريف المضخات",
                    nmbr: "(12)",
                    path: "Pumps",
                    disb: pScr.salesmen,
                    icon: LocalGasStation,
                    action: "zakatSettings",
                },
                {
                    title: "تعريف المستويات",
                    nmbr: "(12)",
                    path: "levels",
                    disb: pScr.salesmen,
                    icon: LocalOffer,
                    action: "electronicScale",
                },
                {
                    title: "تسعيرات الاصناف",
                    nmbr: "(12)",
                    path: "PricesLevels",
                    disb: pScr.salesmen,
                    icon: LocalOffer,
                    action: "generalSettings",
                },
            ],
            [
                {
                    title: "تعريف الجلسات",
                    nmbr: "(12)",
                    path: "TawlaGroups",
                    disb: pScr.salesmen,
                    icon: EventSeat,
                    action: "defaultSettings",
                },
                {
                    title: "تعريف الطاولات",
                    nmbr: "(12)",
                    path: "Tawla",
                    disb: pScr.salesmen,
                    icon: TableChart,
                    action: "systemUpdates",
                },
                {
                    title: "تعريف كود الخصم",
                    nmbr: "(12)",
                    path: "DiscountCode",
                    disb: pScr.salesmen,
                    icon: LocalOffer,
                    action: "importExport",
                },
            ],

        ],
    },
    users: {
        id: "accounts",
        name: "users-and-permissions-title",
        color: "#3479ad",
        dark: "#205581",
        light: "#e6f2fc",
        icon: Group,
        pages: [
            [
                {
                    title: "تعريف الموظف",
                    nmbr: "(1)",
                    path: "employees",
                    disb: pScr.found,
                    icon: PersonAdd,
                    action: "accountsTree",
                },
                {
                    title: "تعديل بيانات المستخدمين",
                    nmbr: "(2)",
                    path: "users-curd",
                    disb: pScr.found,
                    icon: Description,
                    action: "journalEntries",
                },
                {
                    title: "صلاحيات المستخدمين",
                    nmbr: "(3)",
                    path: "user-perms",
                    disb: pScr.found,
                    icon: Security,
                    action: "receiptVoucher",
                },
                {
                    title: "تغيير كلمة المرور",
                    nmbr: "(4)",
                    path: "change-password",
                    disb: true,
                    icon: VpnKey,
                    action: "paymentVoucher",
                },
                {
                    title: "سلف الموظفين",
                    nmbr: "(4)",
                    path: "EmpAdvances",
                    disb: true,
                    icon: Money,
                    action: "trialBalance",
                },
                {
                    title: "سند تسليم راتب الموظفين",
                    nmbr: "(4)",
                    path: "SalaryPay",
                    disb: true,
                    icon: Receipt,
                    action: "accountStatement",
                },
            ],

        ],
    },
    settings: {
        id: "settings",
        name: "إعدادات النظام",
        color: "#49b99b",
        dark: "#239477",
        light: "#e5f8f1",
        icon: Settings,

        pages: [
            [
                {
                    title: "الإعدادات الإفتراضية",
                    nmbr: "(2)",
                    path: "default_setting",
                    disb: true,
                    icon: Tune,
                    action: "defaultSettings",
                },
                {
                    title: "تطبيق التحديثات على النظام",
                    nmbr: "(1)",
                    path: "Refresh",
                    disb: true,
                    icon: SystemUpdate,
                    action: "systemUpdates",
                },
                {
                    title: "استيراد وتصدير البيانات",
                    nmbr: "(4)",
                    path: "",
                    disb: false,
                    icon: CloudUpload,
                    action: "importExport",
                },
                {
                    title: "إعدادات عامة",
                    nmbr: "(5)",
                    path: "permissions",
                    disb: pScr.found,
                    icon: AccountBalance,
                    action: "zakatSettings",
                },
                {
                    title: "إعداد الميزان الالكتروني",
                    nmbr: "(10)",
                    path: "electronic-scale",
                    disb: true,
                    icon: AccountBalance,
                    action: "electronicScale",
                },
                {
                    title: "Zatca Settings",
                    nmbr: "(10)",
                    path: "zatca-settings",
                    disb: true,
                    icon: Settings,
                    action: "generalSettings",
                },
            ],

        ],
    },
};

export default function DeptScreen({
    system,
    onClose,
    onSelect,
    logo,
    customConfig,
}) {

    const [page, setPage] = React.useState(0);
    let his = useHistory();
    // const { t: transForm } = useTranslation(["forms"]);
    const { t } = useTranslation();
    const loca = useLocation();
    let baseConfig =
        SYSTEM_CONFIG[loca.state.system] || SYSTEM_CONFIG.sales;
    React.useEffect(() => {
        setPage(0);
    }, [system]);

    const config = customConfig
        ? {
            ...baseConfig,
            ...customConfig,
            pages: customConfig?.pages || baseConfig.pages,
        }
        : baseConfig;
    const SystemIcon = config?.icon;

    const pages = config.pages || [[]];
    const currentItems = pages[page] || [];
    const cards = Array.from({ length: 6 }, (_, index) => {
        return currentItems[index] || null;
    });

    const goScreen = async (item) => {
        his.push({
            pathname: `/${item.path}`,
            state: item.insh
        })
    };
    const back = () => his.replace({ pathname: '/' });

    return (
        <Box
            className="dept-dashboard"
            dir="rtl"
            style={{
                "--system-color": config.color,
                "--system-dark": config.dark,
                "--system-light": config.light,
            }}
        >
            {/* المحتوى الرئيسي */}
            <main className="dept-main">
                {/* العنوان */}
                <Paper elevation={0} className="dept-title-panel">
                    <div className="dept-title-decoration" />
                    <div className="dept-title-icon">
                        <SystemIcon />
                    </div>
                    <div className="dept-title-content">
                        <Typography
                            component="h1"
                            className="dept-main-title"
                        >
                            {/* {t(config.title)} */}
                            {t('dept-screen-title') + " " + t(config.name)}
                        </Typography>

                        <span className="dept-title-underline" />
                    </div>

                    <div className="dept-title-cloud">
                        <Dashboard />
                    </div>
                </Paper>

                {/* الصفحات */}
                <Paper elevation={0} className="dept-content-panel">
                    {pages.length > 1 && (
                        <div className="dept-tabs-wrapper">
                            <Tabs
                                value={page}
                                onChange={(event, value) => setPage(value)}
                                variant="scrollable"
                                scrollButtons="auto"
                                className="dept-tabs"
                                TabIndicatorProps={{
                                    style: {
                                        backgroundColor: config.color,
                                        height: 3,
                                    },
                                }}
                            >
                                {pages.map((items, index) => (
                                    <Tab
                                        key={index}
                                        label={`صفحة ${index + 1}`}
                                        icon={<Description />}
                                        className="dept-tab"
                                    />
                                ))}
                            </Tabs>
                        </div>
                    )}

                    {/* المربعات الستة */}
                    <Grid
                        container
                        spacing={0}
                        className="dept-cards-grid"
                    >
                        {cards.map((item, index) => {
                            if (!item) {
                                return (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        key={`empty-${page}-${index}`}
                                        className="dept-card-grid-item"
                                    >
                                        <div className="dept-card-empty" />
                                    </Grid>
                                );
                            }

                            const CardIcon = item.icon || Description;

                            return (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    key={`${page}-${item.action || index}`}
                                    className="dept-card-grid-item"
                                >
                                    <Tooltip title={t(item.title)} placement="top">
                                        <button
                                            type="button"
                                            className="dept-option-card"
                                            onClick={() => goScreen(item)}
                                        >
                                            <div className="dept-card-shape" />

                                            <div className="dept-card-icon-circle">
                                                <CardIcon className="dept-card-icon" />
                                            </div>

                                            <div className="dept-card-title">
                                                {t(item.title)}
                                            </div>

                                            <span className="dept-card-arrow">
                                                ‹
                                            </span>
                                        </button>
                                    </Tooltip>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Paper>
            </main>
            {/* الجانب الأيسر */}
            <aside className="dept-sidebar" dir="ltr">
                <Button
                    variant="contained"
                    className="dept-close-button"
                    onClick={back}
                    startIcon={<Close />}
                >
                    {t('close')}
                </Button>

                <div className="dept-brand">
                    {logo ? (
                        <img
                            src={logo}
                            alt="OraxSoft"
                            className="dept-logo"
                        />
                    ) : (
                        <div className="dept-logo-text" dir="ltr">
                            <span>Orax</span>
                            <strong>Soft</strong>
                            <small>Ease Imagination</small>
                        </div>
                    )}
                </div>

                <div className="dept-system-icon">
                    <div className="dept-system-icon-circle">
                        <SystemIcon />
                    </div>

                    <Typography
                        component="div"
                        className="dept-system-name"
                    >
                        {t(config.name)}
                    </Typography>

                    <span className="dept-system-underline" />
                </div>

                <div className="dept-sidebar-footer">
                    <span className="dept-status-dot" />
                    <span>نظام OraxCloud</span>
                </div>
            </aside>

        </Box>
    );
}
